import { useState, useEffect } from "react";
import { FaMoon, FaSun, FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";


export default function Navbar() {
    // Initialize darkMode state based on class presence
    const [darkMode, setDarkMode] = useState(() =>
        document.documentElement.classList.contains("dark")
    );

    const { loading, error, data } = useSelector((state) => state.portfolio);
    console.log(loading, error);
    
    // Sync dark mode class when state changes
    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [darkMode]);

    const toggleDark = () => {
        setDarkMode((prev) => !prev);
    };

    const links = ["Home", "About", "Projects", "Skills", "Experience", "Contact"];

    return (
        <nav className="fixed w-full bg-white dark:bg-gray-900 shadow-md z-50 px-6 py-3 flex justify-between items-center">
            <h1 className="text-2xl font-heading text-indigo-600 font-bold cursor-default">
                MyPortfolio
            </h1>

            <div className="hidden md:flex items-center space-x-8">
                {links.map((link) => (
                    <a
                        key={link}
                        href={`#${link.toLowerCase()}`}
                        className="text-gray-700 dark:text-gray-300 hover:text-indigo-500 dark:hover:text-indigo-400 transition-colors duration-300 font-medium"
                    >
                        {link}
                    </a>
                ))}

                <button
                    onClick={toggleDark}
                    aria-label="Toggle dark mode"
                    className="ml-4 p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                >
                    {darkMode ? (
                        <FaSun className="text-yellow-400" size={20} />
                    ) : (
                        <FaMoon className="text-gray-700" size={20} />
                    )}
                </button>
            </div>

            {/* Mobile Menu and dark toggle */}
            <div className="md:hidden flex items-center space-x-4">
                <button
                    onClick={toggleDark}
                    aria-label="Toggle dark mode"
                    className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                >
                    {darkMode ? (
                        <FaSun className="text-yellow-400" size={20} />
                    ) : (
                        <FaMoon className="text-gray-700" size={20} />
                    )}
                </button>
            </div>
            <div className="md:hidden flex items-center space-x-4">
                <button
                    onClick={() => window.open(data.whatsappUrl, '_blank')}
                    className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                >
                    {darkMode ? (
                        <FaWhatsapp className="text-yellow-400" size={20} />
                    ) : (
                        <FaWhatsapp className="text-green-700" size={20} />
                    )}
                </button>
            </div>
        </nav>
    );
}
